export var FAIRE_DIRECT_BRAND_QUERY_PARAM = "fdb";
